import apiClient from './apiClient';

const dashboardService = {
  getStats: (params = {}) => apiClient.get('/dashboard/stats', { params }),
  getAlertsCount: () => apiClient.get('/dashboard/alerts-count'),
};

export default dashboardService;
